import { InitialViewKeyType } from './constants';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const selectTaskManagerCheckoutDrawerIsOpen = (state: any): boolean =>
  state.get('monetization').taskManagerCheckoutDrawer.isOpen;

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const selectInitialViewKey = (state: any): InitialViewKeyType =>
  state.get('monetization').taskManagerCheckoutDrawer.initialViewKey;
